import { type FeatureCard, FeatureCardSchema } from "@stackje/common/config";
import { ValidationError } from "./validation";

export function parseFeatureCard(formData: FormData): FeatureCard {
  // Parse features from indexed form fields
  const features = [];
  let i = 0;
  while (formData.has(`featureTitle${i}`)) {
    const title = formData.get(`featureTitle${i}`) as string;
    const description = formData.get(`featureDescription${i}`) as string;
    const image = formData.get(`featureImage${i}`) as string;

    // Only add feature if it has required fields
    if (title && description) {
      features.push({
        title,
        description,
        image: image || undefined,
      });
    }
    i++;
  }

  const type = formData.get("type") as "feature1" | "feature2";

  const cardData = {
    type,
    title: formData.get("title") as string,
    subtitle: formData.get("subtitle") as string,
    features,
    colors: JSON.parse(formData.get("colors") as string),
  };

  try {
    return FeatureCardSchema.parse(cardData);
  } catch (error) {
    if (error instanceof Error) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      throw new ValidationError(error as any);
    }
    throw error;
  }
}
